import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  fullName: () => faker.person.fullName(),
  email: () => faker.internet.email(),
  additionalGuests: 0,
  privateNotes: '',
  propertyNotes: '',
  recurringRule: 'FREQ=WEEKLY;BYDAY=MO;',
  skipGuestNotification: false,
  startTime: () => new Date(),
  userData: () => [],
  locationNames: () => [],

  afterCreate(recurringInvite) {
    const flows = recurringInvite.location?.flows?.models;

    if (flows) {
      const [flow] = recurringInvite.location.flows.models;

      recurringInvite.update({ flow });
    }
  },
});
